<template>
<div class="card card-customa">
  <div class="card-header-cus">KANBAN OCORRÊNCIAS</div>
  <div class="kanban-body pr-3 pl-3 pb-4 mr-4">
    <kanban
      :colunas="colunas"
      :nivel_interesse="2"
      v-on:clicaritem="clicaritem"
      @detalhe="detalhe"
      v-on:excluir="excluir"
      v-on:alteracao="GetAllOcourenceKanban"
      v-on:novocard="novocard"
    ></kanban>
  </div>
</div>
</template>

<script>
import kanban from '../kanban/kanban.vue'
import { loading } from '@/shared/utils/UIHelper'
import OcurrenceRepository from '@/shared/http/repositories/realestate/ocurrence'
import Roles from '@/shared/utils/roles.js'
import PermissionMixin from '@/store/module/permission/mixin'
import AccountMixin from '@/store/module/account/mixin'
import CompanyMixin from '@/store/module/company/mixin'
import localStoreHelper from '@/shared/utils/localStoreHelper'
export default {
  name: 'KabanOcorrence',
  props: ['dataSearchDetails'],
  mixins: [AccountMixin, CompanyMixin, PermissionMixin],
  components: {kanban},
  data  () {
    return {
      colunas: [],
      dataSearch: localStoreHelper.controleOcorrencia.ocorrencias() || {},
      ColunasFluxo: [
        { field: 'statusCor', header: '' },
        { field: 'status', header: 'STATUS' },
        { field: 'fornecedor', header: 'FORNECEDOR' },
        { field: 'nivelInteresse', header: 'NÍVEL DE INTERESSE' },
        { field: 'faseFluxo', header: 'FASE DO FLUXO DE COMPRA ' },
        { field: 'produto', header: 'PRODUTO' }
      ],
      popupFluxoDeCompra: false,
      roles: Roles
    }
  },
  mounted () {
    this.GetAllOcourenceKanban()
  },
  methods: {
    dicionar () {
      this.popupFluxoDeCompra = true
    },
    novocard () {

    },
    clicaritem () {

    },
    alteracao () {

    },
    detalhe (data) {
      this.$emit('detalhe', data)
    },
    excluir () {
    },
    GetAllOcourenceKanban () {
      this.colunas = []
      loading.push()
      if (!this.hasRole(this.roles.RW_REAL_ESTA_USER_OBRA)) {
        this.dataSearch.typeAccess = false
      } else {
        this.dataSearch.typeAccess = true
      }
      let data = Object.keys(this.dataSearch).length === 0 ? this.dataSearchDetails : this.dataSearch
      OcurrenceRepository.GetKanban(data, this.typeaccess)
        .then(Response => {
          loading.pop()
          this.colunas = Response.data
        })
        .catch((Error) => loading.pop())
    }
  }
}
</script>

<style scoped>
.card {
  height: 100%;
}
.card-header-cus{
  height: 50px;
  font-family: "Segoe UI";
  padding: 2rem;
  font-size: 16px;
  color: #016422;
  font-weight: bold;
}

.card-customa{
  padding-right: 200px;
  overflow: auto;
  height: 100%;
   border-radius: 9px;
}
.card-customa::-webkit-scrollbar-track {
    background-color: #F4F4F4;
    border-radius: 15px;
}
.card-customa::-webkit-scrollbar {
    width: 3px;
    height: 10px;
     border-radius: 9px;
    background: #F4F4F4;
}
.card-customa::-webkit-scrollbar-thumb {
    background: rgb(192, 193, 192);
    border-radius: 9px;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/ocurrence/components/KabanOcorrence/KabanOcorrence.vue